import React, { Suspense } from 'react';
import './style.less';
import { TEMPLATES } from '../../constants';
import { Col, Row, Tooltip, Typography } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Loader from '../Loader/Loader';

const CardWrapper = ({ template, current, language }) => {
  const { t } = useTranslation(['template', 'translation']);
  return (
    <div className={`card ${current === template?.id['en'] && 'selected'}`}>
      <div className="image-container">
        <img
          src={template.image}
          alt={t(`${template.key}.title`)}
          // style={{
          //   width: '60px',
          //   height: '65px',
          // }}
        />
      </div>
      <div className="card-text">
        <h4 className="card-title">{t(`${template.key}.title`)}</h4>
        <p className="card-desc">{t(`${template.key}.description`)}</p>
      </div>
      <a
        href={template.url[language] ?? template.url['en']}
        target="_blank"
        rel="noreferrer"
        style={{
          textDecoration: 'none',
          color: '#525252',
        }}
        onClick={(e) => e && e.stopPropagation()}
      >
        <Tooltip title={t('translation:common.preview', 'preview')} placement="bottom">
          <EyeOutlined />
        </Tooltip>
      </a>
    </div>
  );
};

const TemplateCards = ({ selectedTemplate, setTemplate, onCardClick, language }) => {
  const { t } = useTranslation();
  return (
    <div className="Template-cards">
      <Suspense fallback={<Loader />}>
        <Typography.Title level={4}>{t('templateHeader', 'Templates')}</Typography.Title>
        <Row gutter={[16, 16]} className="card-container">
          {TEMPLATES.map((template, i) => (
            <Col
              key={i}
              xs={24}
              sm={24}
              md={12}
              onClick={() =>
                onCardClick('template', { templateId: template.id[language] ?? template.id['en'] })
              }
            >
              <CardWrapper template={template} current={selectedTemplate} language={language} />
            </Col>
          ))}
        </Row>
      </Suspense>
    </div>
  );
};

export default TemplateCards;
